  import React, { Fragment } from 'react';
import { DataConsumer } from '../context/DataContext';

import Hero from '../components/home/Hero';
import About from '../components/home/About';
import Experience from '../components/home/Experience';
import Contact from '../components/home/Contact';

const Home = props => (
  <DataConsumer>
    {({data: {hero, about, experience, contact}}) => (
      <Fragment>
        <Hero
          data={hero}
        />
        <About
          data={about}
        />
        <Experience
          data={experience}
        />
        <Contact
          data={contact}
        />
      </Fragment>
    )}
  </DataConsumer>
);

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.js